import { Icon } from 'ui';
import React from 'react';
import './_chat-action-pills.scss';
import type { ChatActionPillsProps, ChatPillConfig } from './types';

/**
 * ChatActionPills - Reusable pill-shaped action buttons for the chatbot
 *
 * Displays 1-2 pill buttons above the chat input for contextual actions
 * such as retry after error, quick actions, or feedback collection.
 */
function ChatActionPills({ pills, className }: ChatActionPillsProps): JSX.Element | null {
  if (pills.length === 0) {
    return null;
  }

  return (
    <div className={`chat-action-pills ${className || ''}`}>
      {pills.map((pill: ChatPillConfig) => (
        <button
          key={pill.id}
          type="button"
          className={`chat-action-pills__pill chat-action-pills__pill--${pill.variant || 'primary'}`}
          onClick={pill.onClick}
          disabled={pill.disabled}
        >
          {pill.icon && <Icon name={pill.icon} size="s" color="primary" />}
          <span className="chat-action-pills__text">{pill.text}</span>
        </button>
      ))}
    </div>
  );
}

export default ChatActionPills;
